export class ListGoogleWorkspaceOrgUnits200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "orgUnits",
            "baseName": "orgUnits",
            "type": "Array<GoogleWorkspaceOrgUnit>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGoogleWorkspaceOrgUnits200Response.attributeTypeMap;
    }
    constructor() {
    }
}
